import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import featureServicePlanItemDetailsStyles from './featureServicePlanItemDetailsStyles';
import IPrice from '../../../../../../../gqlCommon/model/prices/IPrice';
import FeatureServiceInterval from '../featureServiceInterval/FeatureServiceInterval';
import Translation from '../../../../../../../gqlCommon/components/translation/Translation';
import { GetFeatureChildren_featureChildren } from '../../../../../../graphql/queries/__generated__/GetFeatureChildren';
import Price from '../../../../../../../gqlCommon/components/presentation/Price';
import clsx from 'clsx';
import { PriceDisplayType } from '../../../../../../../../../common/enum/PriceDisplayType';

export interface IFeatureServicePlanItemDetailsProps {
  planPrice: IPrice;
  serviceIntervals: GetFeatureChildren_featureChildren[];
}

const FeatureServicePlanItemDetails: FunctionComponent<IFeatureServicePlanItemDetailsProps> = ({
  planPrice,
  serviceIntervals,
}) => {
  const styles = featureServicePlanItemDetailsStyles();

  return (
    <Box mt={3} data-test="customise:featureServicePlan:details">
      <Box display="flex" justifyContent="space-between">
        <Typography className={styles.headerItem}>
          <Translation id="trans__configurator__customise_page_service_section__sp_intervals_label" />
        </Typography>
        <Typography className={styles.headerItem}>
          <Translation id="trans__configurator__customise_page_service_section__sp_intervals_cost_label" />
        </Typography>
      </Box>
      {serviceIntervals?.map(serviceInterval => (
        <FeatureServiceInterval key={serviceInterval.code} serviceInterval={serviceInterval} />
      ))}
      <Box className={styles.totalContainer}>
        <Typography className={styles.totalLabel} variant="body1">
          <Translation id="trans__configurator__customise_page_service_section__sp_intervals_total_label" />
        </Typography>
        <Typography className={styles.headerItem}>
          <Price
            className={clsx(styles.totalValue)}
            price={planPrice?.money.amount}
            data-test={'customise:featureServicePlanIntervalTotal'}
            priceDisplayType={PriceDisplayType.PRIMARY_OPTIONS}
          />
        </Typography>
      </Box>
    </Box>
  );
};

export default FeatureServicePlanItemDetails;
